"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
/**
 * Maps the legacy theme format to the new spec defined in `@zip/theme`
 */
var theme = {
    name: 'legacy',
    borders: {},
    borderStyles: {},
    borderWidths: [],
    breakpoints: [600],
    colors: {
        get background() {
            return this.white;
        },
        get title() {
            return this.secondary;
        },
        get body() {
            var _a;
            return (_a = this.neutral) === null || _a === void 0 ? void 0 : _a[600];
        },
        primary: {
            lightest: '#fff',
            lighter: polished_1.rgba('#1C70F2', 0.04),
            main: '#21285E',
            medium: '#1C70F2',
            dark: '#1C70F2',
        },
        secondary: '#21285E',
        get tertiary() {
            var _a;
            return (_a = this.neutral) === null || _a === void 0 ? void 0 : _a[500];
        },
        get accent() {
            var _a;
            return (_a = this.primary) === null || _a === void 0 ? void 0 : _a.medium;
        },
        muted: '',
        neutral: {
            0: '#F8FAFB',
            50: '#F9F9FB',
            100: '#F2F2F2',
            200: '#E8E8EC',
            300: '#DDDDE3',
            400: '#A5ABC1',
            500: '#6E7396',
            600: '#424876',
        },
        success: '#00AEB8',
        info: '',
        warning: '#F8991C',
        danger: '#B00020',
        black: '#000',
        white: '#fff',
    },
    fonts: {
        title1: {
            family: 'Rubik, sans-serif',
            size: polished_1.rem(40),
            letterSpacing: polished_1.rem(-1),
            lineHeight: polished_1.rem(48),
            weight: 400,
        },
        title2: {
            family: 'Rubik, sans-serif',
            size: polished_1.rem(32),
            letterSpacing: polished_1.rem(-1),
            lineHeight: polished_1.rem(40),
            weight: 400,
        },
        title3: {
            family: 'Rubik, sans-serif',
            size: polished_1.rem(28),
            letterSpacing: polished_1.rem(-0.8),
            lineHeight: polished_1.rem(32),
            weight: 400,
        },
        title4: {
            family: 'Rubik, sans-serif',
            size: polished_1.rem(28),
            letterSpacing: polished_1.rem(-0.8),
            lineHeight: polished_1.rem(32),
            weight: 400,
        },
        heading1: {
            family: 'Rubik, sans-serif',
            size: polished_1.rem(22),
            letterSpacing: polished_1.rem(-0.6),
            lineHeight: polished_1.rem(28),
            weight: 400,
        },
        heading2: {
            family: 'Rubik, sans-serif',
            size: polished_1.rem(20),
            letterSpacing: polished_1.rem(-0.6),
            lineHeight: polished_1.rem(26),
            weight: 400,
        },
        heading3: {
            family: 'Rubik, sans-serif',
            size: polished_1.rem(17),
            letterSpacing: polished_1.rem(-0.6),
            lineHeight: polished_1.rem(24),
            weight: 400,
        },
        heading4: {
            family: 'Rubik, sans-serif',
            size: polished_1.rem(17),
            letterSpacing: polished_1.rem(-0.4),
            lineHeight: polished_1.rem(24),
            weight: 400,
        },
        body1: {
            family: 'Rubik, sans-serif',
            size: polished_1.rem(15),
            letterSpacing: polished_1.rem(-0.4),
            lineHeight: polished_1.rem(22),
            weight: 400,
        },
        body2: {
            family: 'Rubik, sans-serif',
            size: polished_1.rem(15),
            letterSpacing: polished_1.rem(-0.3),
            lineHeight: polished_1.rem(22),
            weight: 400,
        },
        body3: {
            family: 'Rubik, sans-serif',
            size: polished_1.rem(13),
            letterSpacing: polished_1.rem(-0.3),
            lineHeight: polished_1.rem(18),
            weight: 400,
        },
        body4: {
            family: 'Rubik, sans-serif',
            size: polished_1.rem(13),
            letterSpacing: polished_1.rem(-0.3),
            lineHeight: polished_1.rem(18),
            weight: 400,
        },
        caption1: {
            family: 'Rubik, sans-serif',
            size: polished_1.rem(11),
            letterSpacing: polished_1.rem(-0.3),
            lineHeight: polished_1.rem(15),
            weight: 400,
        },
        caption2: {
            family: 'Rubik, sans-serif',
            size: polished_1.rem(40),
            letterSpacing: polished_1.rem(-0.3),
            lineHeight: polished_1.rem(15),
            weight: 400,
        },
        caption3: {
            family: 'Rubik, sans-serif',
            size: polished_1.rem(8),
            letterSpacing: polished_1.rem(-0.2),
            lineHeight: polished_1.rem(2),
            weight: 400,
        },
        caption4: {
            family: 'Rubik, sans-serif',
            size: polished_1.rem(8),
            letterSpacing: polished_1.rem(-0.2),
            lineHeight: polished_1.rem(2),
            weight: 400,
        },
    },
    fontSizes: {
        title1: polished_1.rem(40),
        title2: polished_1.rem(32),
        title3: polished_1.rem(28),
        title4: polished_1.rem(28),
        heading1: polished_1.rem(22),
        heading2: polished_1.rem(20),
        heading3: polished_1.rem(17),
        heading4: polished_1.rem(17),
        body1: polished_1.rem(15),
        body2: polished_1.rem(15),
        body3: polished_1.rem(13),
        body4: polished_1.rem(13),
        caption1: polished_1.rem(11),
        caption2: polished_1.rem(11),
        caption3: polished_1.rem(8),
        caption4: polished_1.rem(8),
    },
    fontWeights: {
        light: 700,
        normal: 400,
        medium: 500,
        bold: 700,
    },
    letterSpacings: {
        title1: polished_1.rem(-1),
        title2: polished_1.rem(-1),
        title3: polished_1.rem(-0.8),
        title4: polished_1.rem(-0.8),
        heading1: polished_1.rem(-0.6),
        heading2: polished_1.rem(-0.6),
        heading3: polished_1.rem(-0.4),
        heading4: polished_1.rem(-0.4),
        body1: polished_1.rem(-0.3),
        body2: polished_1.rem(-0.3),
        body3: polished_1.rem(-0.3),
        body4: polished_1.rem(-0.3),
        caption1: polished_1.rem(-0.3),
        caption2: polished_1.rem(-0.3),
        caption3: polished_1.rem(-0.2),
        caption4: polished_1.rem(-0.2),
    },
    lineHeights: {
        title1: polished_1.rem(48),
        title2: polished_1.rem(40),
        title3: polished_1.rem(32),
        title4: polished_1.rem(32),
        heading1: polished_1.rem(28),
        heading2: polished_1.rem(26),
        heading3: polished_1.rem(24),
        heading4: polished_1.rem(24),
        body1: polished_1.rem(22),
        body2: polished_1.rem(22),
        body3: polished_1.rem(18),
        body4: polished_1.rem(18),
        caption1: polished_1.rem(15),
        caption2: polished_1.rem(15),
        caption3: polished_1.rem(12),
        caption4: polished_1.rem(12),
    },
    opacities: [],
    radii: {
        md: '4px',
        lg: '25px',
    },
    shadows: {},
    sizes: {
        full: '100%',
    },
    space: [],
    transitions: {},
    zIndices: {},
};
exports.default = theme;
